/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */

/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import Menu from "../../const/sideMenu";
const Sidebar = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const [openSubmenus, setOpenSubmenus] = useState(() =>
    Menu.map((m) => m.children?.some((c) => pathname.startsWith(c.url)) ?? false)
  );
  // console.log("pageurl", pathname);

  const [isSidebarExpanded, setSidebarExpanded] = useState(false);
  const [isMouseOverSidebar, setMouseOverSidebar] = useState(false);

  useEffect(() => {
    setOpenSubmenus((prev) =>
      Menu.map((m, i) => m.children?.some((c) => pathname.startsWith(c.url)) ?? prev[i] ?? false)
    );
  }, [pathname]);

  useEffect(() => {
    if (
      isMouseOverSidebar &&
      document.body.classList.contains("mini-sidebar")
    ) {
      document.body.classList.add("expand-menu");
      return;
    }
    document.body.classList.remove("expand-menu");
  }, [isMouseOverSidebar]);

  const handleMouseEnter = () => {
    setMouseOverSidebar(true);
  };

  const handleMouseLeave = () => {
    setMouseOverSidebar(false);
  };
  const { t } = useTranslation();

  const toggleSubmenu = (index) => {
    setOpenSubmenus((prev) => prev.map((open, i) => (i === index ? !open : open)));
  };

  return (
    <div
      className={`sidebar ${isSidebarExpanded ? "" : "hidden"}`}
      id="sidebar"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="sidebar-inner slimscroll" style={{ overflow: false }}>
        <div id="sidebar-menu" className="sidebar-menu">
          <Scrollbars
            autoHide={false}
            autoHideTimeout={1000}
            autoHideDuration={200}
            autoHeight
            autoHeightMin={0}
            autoHeightMax="100vh"
            thumbMinSize={30}
            universal={false}
            hideTracksWhenNotNeeded={true}
          >
            <ul className="sidebar-vertical" id="veritical-sidebar"></ul>
            <ul>
              {Menu.map((m, i) => {
                if (m.children?.length) {
                  const isActive = pathname.startsWith(m.url);
                  const isOpen = openSubmenus[i] || isActive;
                  return (
                    <li key={i} className={`submenu${isActive ? " active" : ""}`}>
                      <button
                        type="button"
                        className={isActive ? "active" : ""}
                        onClick={() => toggleSubmenu(i)}
                      >
                        <i className={m.imageClass} />
                        {t(m.name)}
                        <span className="menu-arrow" />
                      </button>
                      <ul style={{ display: isOpen ? "block" : "none" }}>
                        {m.children.map((child, j) => (
                          <li key={j}>
                            <Link
                              className={
                                child.url === "/analytics-usage"
                                  ? pathname === child.url || pathname === `${child.url}/`
                                    ? "active"
                                    : ""
                                  : pathname.startsWith(child.url)
                                    ? "active"
                                    : ""
                              }
                              to={child.url}
                            >
                              {t(child.name)}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                  );
                }

                return (
                  <li key={i}>
                    <Link
                      className={pathname.includes(m.url) ? "active" : ""}
                      to={m.url}
                    >
                      <i className={m.imageClass} />
                      {t(m.name)}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </Scrollbars>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
